import { useState, useEffect, useMemo } from "react";
import { Box, Grid } from "@mui/material";
import { connect, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import AlertDialogBox from "../../common/Components/AlertDialogBox";
import ViewAllAlerts from "../../common/Components/ViewAllAlerts";
import PowerBIReportEmbed from "../PowerBIReportEmbed";
import { setPowerBiData } from "../../store/Actions";
import KPIService from "../../services/console_services/KPI";
import MapService from "../../services/console_services/Map";
import { setViewPowerBi } from "../../store/Actions";
import useTabList from "../../common/TabList";
import UserDetailsServices from "../../services/console_services/LoginLogot";
import TabComponent from "../../common/Components/TabComponent";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2.5, 2.5, 1.25, 10),
    fontFamily: theme.fontFamily,
  },
  gridItem: {
    paddingTop: theme.spacing(2),
  },
}));

const DO_DP = ({
  tabIndex,
  Network,
  DC,
  Products,
  date,
  applyFilter,
  Division,
  PL3,
  periodType,
  role,
  viewPowerBi,
  setViewPowerBi,
}) => {
  const classes = useStyles();
  const { instance } = useMsal();
  const [viewAll, setViewAll] = useState(false);
  const [KPIData, setKPIData] = useState({});
  const [KPILoading, setKPILoading] = useState(true);
  const [mapData, setMapData] = useState([]);
  const [MapLoading, setMapLoading] = useState(false);
  const dispatch = useDispatch();
  const TabList = useTabList();
  const currentTabData = useMemo(() => TabList["DO_DP"][tabIndex], [tabIndex]);
  const reduxState = useSelector((state) => state);
  const [kpiPowerBi, setKpiPowerBI] = useState("");

  let reduxTab = reduxState?.tabs?.tabName;

  let moduleType;
  if (reduxTab) {
    if (reduxTab === "DOM") {
      moduleType = "DOM";
    }
    if (reduxTab === "SNO") {
      moduleType = "SNO";
    }
    if (reduxTab === "Deployment Planning") {
      moduleType = "DP";
    }
    if (reduxTab === "Deployment Optimization" || reduxTab === "DO") {
      moduleType = "DO";
    }
    if (reduxTab === "FG Salvage" || reduxTab === "FGS") {
      moduleType = "FGS";
    }
  }
  const fetchCreateAlertsWithUser = () => {
    UserDetailsServices.createAlertsWithUser(
      {
        module: moduleType,
      },
      instance
    );
    UserDetailsServices.createAlertsWithThresholdUser(
      {
        module: moduleType,
      },
      instance
    );
  };

  useEffect(() => {
    const fetchMapData = async () => {
      const params = {
        name: currentTabData.value,
        Level: role,
        filter: {
          RecommendedDC: DC,
          Network,
          PL3,
          Division,
          MaterialID: Products,
          startDate: date[0],
          endDate: date[1],
        },
      };

      setMapLoading(true);
      MapService.getMAP(params, instance)
        .then((data) => {
          if (data?.data) {
            setMapData(data?.data);
          }
        })
        .catch((error) => console.error("Error:", error))
        .finally(() => setMapLoading(false));
    };
    fetchCreateAlertsWithUser();
    fetchMapData();
  }, [tabIndex, role, applyFilter, DC, Network, PL3, Division, Products, date]);

  useEffect(() => {
    const fetchKPIData = async () => {
      const params = {
        name: currentTabData.value,
        periodType,
        Level: role,
        filter: {
          RecommendedDC: DC,
          Network,
          PL3,
          Division,
          MaterialID: Products,
          startDate: date[0],
          endDate: date[1],
        },
      };

      setKPILoading(true);
      KPIService.getKPI(params, instance)
        .then((data) => {
          if (data?.response) {
            setKPIData(data?.response);
          }
        })
        .catch((error) => console.error("Error:", error))
        .finally(() => setKPILoading(false));
    };
    fetchKPIData();
  }, [tabIndex, periodType, role, applyFilter, DC, Network, Products]);

  const toggleViewAll = () => setViewAll(!viewAll);

  const toggleViewPowerBi = (val) => {
    setKpiPowerBI(val);
    setViewPowerBi(!viewPowerBi);
    dispatch(setPowerBiData(val));
  };

  return (
    <Box className={classes.root}>
      {viewPowerBi ? (
        <PowerBIReportEmbed selectedPowerData={kpiPowerBi} />
      ) : (
        <>
          {!viewAll ? (
            <Grid container spacing={2}>
              <Grid item xs={12} md={9}>
                <TabComponent
                  KPIData={KPIData}
                  mapData={mapData}
                  tabList={TabList["DO_DP"]}
                  MapLoading={MapLoading}
                  KPILoading={KPILoading}
                  Module={currentTabData.value}
                  handleViewPowerBi={toggleViewPowerBi}
                  graphViewTabList={TabList["DO_DP"][tabIndex].graphViewTabList}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                className={classes.gridItem}
                sx={{ mt: "93px" }}
              >
                <AlertDialogBox
                  handleViewAll={toggleViewAll}
                  handleViewPowerBi={toggleViewPowerBi}
                  viewAll={viewAll}
                />
              </Grid>
            </Grid>
          ) : (
            <ViewAllAlerts viewAll={viewAll} handleClose={toggleViewAll} />
          )}
        </>
      )}
    </Box>
  );
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  periodType: state.filter.periodType,
  PL3: state.filter.PL3,
  date: state.filter.Date,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
  viewPowerBi: state.viewPowerBi.viewPowerBi,
});

const mapDispatchToProps = {
  setViewPowerBi,
};

export default connect(mapStateToProps, mapDispatchToProps)(DO_DP);
